import PropTypes from 'prop-types';
import React from 'react';
import CrmAvatar from '../../shared/components/CrmAvatar';
import RowActionButtons from './RowActionButtons';
import { formatDateLine, formatEventTimes, formatGross, formatSupportNames } from '../utils/format';
import { CapacityMeter } from '@opendate-app/setlist';

const MobileEventList = ({ events, loading, error, activeTab, timeZone, team }) => {
  if (loading) return <div className="tickets-mobile-empty">Loading…</div>;
  if (error) return <div className="tickets-mobile-empty tickets-mobile-empty--error">{error}</div>;
  if (events.length === 0) {
    return (
      <div className="tickets-mobile-empty">
        No events {activeTab === 'on_sale_now' ? 'are currently on sale' : 'to show'}.
      </div>
    );
  }

  return (
    <div className="tickets-mobile-list">
      {events.map((event) => {
        const tz = event.venue_time_zone || timeZone;
        const dateLine = formatDateLine(event.event_date, tz);
        const eventTimes = formatEventTimes(event, tz);
        const support = formatSupportNames(event.support_names);
        const sold = event.tickets_sold || 0;
        const capacity = event.venue_capacity || 0;

        return (
          <div key={event.id} className="tickets-mobile-card">
            <div className="tickets-mobile-card-header">
              <CrmAvatar
                avatarUrl={event.headliner_image_url}
                name={event.headliner_name || event.event_name}
                size={32}
              />
              <div className="tickets-event-info" style={{ flex: 1 }}>
                <a
                  href={`/teams/${team.id}/confirms/${event.id}`}
                  className="tickets-mobile-card-name tickets-row-link"
                >
                  {event.event_name}
                </a>
                {support && (
                  <div className="tickets-mobile-card-support">{support}</div>
                )}
              </div>
              <div className="tickets-mobile-card-gross">
                <div className="tickets-mobile-card-gross-label">Gross</div>
                <div className="tickets-mobile-card-gross-value">
                  {formatGross(event.tickets_gross || 0)}
                </div>
              </div>
            </div>

            <div className="tickets-mobile-card-section">
              <CapacityMeter
                size="sm"
                label="none"
                unit="tickets"
                taken={sold}
                capacity={capacity}
              />
            </div>

            <div className="tickets-mobile-card-footer">
              <span className="tickets-mobile-card-footer-date">
                {dateLine}{eventTimes ? ` · ${eventTimes}` : ''}
              </span>
              <span className="tickets-mobile-card-footer-venue">
                {event.venue_name || '—'}
              </span>
            </div>

            <div className="tickets-mobile-card-actions">
              <RowActionButtons team={team} event={event} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

MobileEventList.propTypes = {
  events: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
  activeTab: PropTypes.string,
  timeZone: PropTypes.string,
  team: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired,
};

export default MobileEventList;
